import { FC, memo } from 'react';

import Grid2 from '../../components/grid/Grid2';
import { H2, H3 } from '../../components/heading/Hx';
import Paragraph from '../../components/paragraph/Paragraph';
import Section from '../../components/section/Section';
import { COLOR } from '../../theme/type';

const WasDuBist: FC = () => (
  <Section background={COLOR.Dark1}>
    <H2 center>Was Du bist, bekommst Du...</H2>

    <Grid2 spacing='2rem'>
      <Grid2.Item>
        <H3>Mehr als nur Kampfkunst</H3>
        <Paragraph>
          Systema ist mehr als nur eine Kampfkunst – es ist ein achtsamer Weg der Selbsterkenntnis.
          Das Training vermittelt nicht nur körperliche Techniken, sondern ist ein ganzheitlicher
          Ansatz, der sich auf viele Lebensbereiche übertragen lässt. Die Prinzipien und Konzepte
          fördern nicht nur die physische, sondern auch die mentale und emotionale Entwicklung.
        </Paragraph>
        <Paragraph>
          Besonders im langsamen Training können unbewusste Einstellungen und Glaubenssätze
          offenbart werden. Diese Achtsamkeit ermöglicht es dem Praktizierenden, Spannungen zu
          erkennen und Wege zur Entspannung zu finden. Gleichzeitig verbessert das Training die
          körperliche und geistige Stabilität. Es werden Fehlhaltungen korrigiert, unnötige
          Bewegungen und Gedanken vermieden und die Belastbarkeit erhöht.
        </Paragraph>
      </Grid2.Item>

      <Grid2.Item>
        <H3>Dein Weg mit Herz</H3>
        <Paragraph>
          Was und Warum Du bist, beeinflusst maßgeblich Deine Lebensumstände. Deine innere Haltung
          und Ausstrahlung ziehen ähnliche Energien an. Wenn Du entspannt und stark bist, wird sich
          das in Form von positiven Ereignissen und bereichernden Beziehungen in Deinem Leben
          zeigen.
        </Paragraph>
        <Paragraph>
          Systema bietet Dir die Möglichkeit, Deinen Weg mit Herz zu finden. So kannst du
          authentisch sein und das Leben führen, das wirklich zu Dir passt und das Du liebst. Nutze
          diese Chance, um herauszufinden, was Dir Freude bereitet und was dich erfüllt.
        </Paragraph>
        <Paragraph>
          Probiere es aus und finde deinen individuellen Weg, der dich zu mehr Zufriedenheit und
          Erfüllung führt!
        </Paragraph>
      </Grid2.Item>
    </Grid2>
  </Section>
);

export default memo(WasDuBist);
